export const APP_STORE_URL = 'https://apps.apple.com/app/zwyk/id6748926827';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=pl.zwyk';
export const WEBSITE_URL = process.env.NODE_ENV === "development" ? 'http://localhost:3000' : 'https://zwyk.pl';
